/**
 * @generated SignedSource<<f3425a6f66660ce89fd467f35b6e7a6c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DepartmentAvailabilityFiltersModal_department$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DepartmentAvailabilityCoursePicker_department" | "DepartmentAvailabilityGroupSizeSelect_department" | "DepartmentAvailabilityTimeSliderFragment_department" | "departmentToScheduleOption_department">;
  readonly " $fragmentType": "DepartmentAvailabilityFiltersModal_department";
};
export type DepartmentAvailabilityFiltersModal_department$key = {
  readonly " $data"?: DepartmentAvailabilityFiltersModal_department$data;
  readonly " $fragmentSpreads": FragmentRefs<"DepartmentAvailabilityFiltersModal_department">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DepartmentAvailabilityFiltersModal_department",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DepartmentAvailabilityTimeSliderFragment_department"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DepartmentAvailabilityGroupSizeSelect_department"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DepartmentAvailabilityCoursePicker_department"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "departmentToScheduleOption_department",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Department",
  "abstractKey": null
};

(node as any).hash = "281b7168793862d83254290af46d098a";

export default node;
